export default {
    signUpSidebar: {
        title: "Welcome on Board",
        smartWallet: {
            title: "Create Smart Wallet (Recommended)",
            titleConnect: "Connect Smart Wallet",
            description:
                "Create a smart wallet to receive payments and manage your earnings. You can use this wallet across many websites.",
            buttonCreate: "Create Wallet",
            buttonConnect: "Connect Wallet",
        },
        emailLogin: {
            titleLogin: "Log in With E-Mail",
            titleSignup: "Register With E-Mail",
            description: "You can log in securely with your email address.",
            placeholder: "lord-of@talentir.com",
            buttonLogin: "Log In",
            buttonSignup: "Sign Up",
            errorInvalidEmail: "Invalid Email",
        },
        browserWallet: {
            title: "Connect With Browser Wallet",
            description: "Connect your browser wallet like MetaMask to securely log in with your existing Web3 wallet.",
        },
        accountSwitch: {
            newUser: "New Here?",
            existingUser: "Already Have An Account",
            signUp: "Sign Up",
            logIn: "Log In",
        },
        otpVerification: {
            title: "Please enter the token we sent to",
            retry: "Wrong Token!",
            retryMessage: "Please reenter the token we sent to",
        },
        loading: {
            wait: "Please wait...",
            connectWallet: "Connect your wallet",
            signMessage: "Sign the message",
            loadingWallet: "Loading your wallet...",
            connectingWallet: "We are connecting your wallet",
            connectWith: "Log in by connecting your",
            requestSign: "Requesting the message to sign.",
            waitSign: "Waiting for the message to be signed.",
            verifySign: "Verifying the signature.",
            loadProfile: "Loading the user profile.",
        },
        walletConfirm: {
            title: "Confirm Wallet",
            description: "For security we need your confirmation. You are already connected as",
            useDifferent: "Use Different Account",
            confirm: "Confirm",
        },
    },
    campaignPayout: {
        title: "Unclaimed Payout",
        description: "You have an unclaimed payout. Create a wallet and connect your TikTok account to claim it.",
        details: {
            tiktokHandle: "TikTok Handle",
            payoutAmount: "Payout Amount",
            sender: "Sender",
            description: "Description",
        },
        buttons: {
            logIn: "Log In",
            signUp: "Sign Up",
            claimPayout: "Claim Payout",
            goToDashboard: "Go to Dashboard",
            contactSupport: "Contact Support",
        },
        status: {
            alreadyPaid: "Already paid out",
            notApproved: "Not yet approved! Contact Support",
        },
        errors: {
            campaignNotFound: "Campaign Not Found",
            wrongTikTokAccount:
                "The TikTok account {handle} is connected to a different wallet. Please log out and connect with this wallet.",
            logOut: "Log out",
            linkExpired: "This payout link has expired",
        },
        progressSteps: {
            signIn: "Sign Up",
            connectTiktok: "Connect TikTok",
            payout: "Payout",
        },
    },
    paymentDialogs: {
        campaignDialog: {
            idle: {
                title: "Claim Payouts",
                "description#zero": "You have no unclaimed payouts.",
                "description#one": "You are claiming a payout.",
                "description#other": "You are claiming {count} payouts.",
                details: {
                    campaignName: "Campaign Name",
                    payoutAmount: "Payout Amount",
                    payoutFee: "Payout Fee",
                    period: "Period",
                    total: "Total",
                    fee: "Fee",
                    type: "Type",
                },
                buttons: {
                    continue: "Continue",
                },
            },
        },
        common: {
            paymentMethod: {
                title: "Payment Method",
                description: "Please chose how you want to receive your payment.",
                methods: {
                    bank: {
                        title: "Bank Transfer",
                        description: "Paid out to your Bank Account.",
                        badge: "Instant",
                    },
                    crypto: {
                        titleUSD: "USDC",
                        titleEUR: "EURC",
                        description: "Paid on the Blockchain.",
                        badge: "Instant",
                    },
                },
            },
            confirm: {
                details: {
                    payoutMethod: {
                        title: "Payout Method",
                        wallet: "Your Wallet ({currency})",
                        bank: "SEPA Bank Transfer",
                    },
                    wallet: {
                        title: "Wallet",
                    },
                    bankAccount: {
                        title: "Bank Account",
                        error: "Please fill out your account number",
                    },
                    address: {
                        title: "Receipt Address",
                        error: "Please fill out your address",
                    },
                    payoutAmount: {
                        title: "Payout Amount",
                    },
                    vat: {
                        title: "Tax Information",
                        taxExempt: "Small Business Tax Exempt",
                        tinMissing: "Tax Identification Number Missing",
                        tax: "Tax",
                    },
                    payoutAmountGross: {
                        title: "Payout Amount (Plus VAT)",
                    },
                },
                buttons: {
                    edit: "Edit",
                    goBack: "Go Back",
                    claim: "Give Me Money",
                },
                alert: {
                    title: "Are you sure?",
                    description: "This action is irreversible. You will receive your payout to the selected method.",
                    terms: "I accept the {link}. I take full responsibility for the accuracy of the information provided.",
                    link: "Terms & Conditions",
                    cancel: "Cancel",
                    confirm: "Confirm",
                },
            },
            success: {
                title: "Transaction Successful",
                wallet: {
                    description: "Your payout has been completed successfully.",
                },
                buttons: {
                    close: "Close",
                },
            },
            addressEdit: {
                title: "Edit Address",
                buttons: {
                    goBack: "Go Back",
                    save: "Save",
                },
            },
            editVat: {
                title: "Edit Tax Information",
                buttons: {
                    goBack: "Go Back",
                },
            },
            editBankDetails: {
                title: "Edit Bank Details",
                buttons: {
                    goBack: "Go Back",
                },
            },
        },
    },
    personalData: {
        form: {
            firstName: {
                label: "First Name",
                placeholder: "Your First Name",
                description: "Your First Name as Written On Official Documents",
            },
            lastName: {
                label: "Last Name",
                placeholder: "Your Last Name",
                description: "Your Last Name as Written On Official Documents",
            },
            organization: {
                label: "Organization",
                placeholder: "Your Organization",
                description: "Leave this empty if you're represented as a private person",
            },
            addressLine1: {
                label: "Address Line 1 *",
                placeholder: "Your Address Line 1",
            },
            addressLine2: {
                label: "Address Line 2",
                placeholder: "Your Address Line 2",
            },
            city: {
                label: "City *",
                placeholder: "Your City",
            },
            state: {
                label: "State",
                placeholder: "Your State",
            },
            postalCode: {
                label: "Zip/Postal Code *",
                placeholder: "Your Zip/Postal Code",
            },
            country: {
                label: "Country *",
                placeholder: "Select Country",
                searchPlaceholder: "Search nationality...",
                notFound: "No country found.",
            },
            vatId: {
                label: "Company VAT ID",
                placeholder: "Your Company VAT ID",
                description: "If you have a VAT ID, you need to provide it here",
            },
        },
        buttons: {
            save: "Save",
            continue: "Continue",
            goBack: "Go Back",
        },
    },
    vatData: {
        title: "VAT Status",
        description: "Select whether you are a VAT payer in Europe.",
        options: {
            exempt: "I'm VAT exempt",
            payer: "I need to pay VAT in Europe",
        },
        notEuCountry: "You are not in an EU country. No need to provide VAT information.",
        vatNumber: {
            label: "VAT Number",
            placeholder: "Enter your VAT number",
            description: "Enter your European VAT registration number",
        },
        tinNumber: {
            label: "Tax Identification Number (TIN)",
            placeholder: "xxx/xxxx/xxxx",
            description:
                "Enter your Tax Identification Number. You take responsibility for the accuracy of the information provided.",
        },
        vatPercentage: {
            label: "VAT Percentage",
            description: "Enter your applicable VAT percentage for sending invoices",
        },
        buttons: {
            save: "Save",
        },
        confirmDialog: {
            title: "Warning: Tax Information",
            descriptionVat:
                "By confirming, you are stating that the provided VAT-ID is accurate and belongs to you. Providing false information may constitute tax fraud.",
            descriptionTin:
                "By confirming, you are stating that the provided Tax Identification Number is accurate and belongs to you.",
            buttons: {
                cancel: "Cancel",
                confirm: "Confirm",
            },
        },
    },
    bankData: {
        accountType: {
            label: "Account Type",
            placeholder: "Select account type",
            description: "Select your bank account type.",
            sepa: "SEPA Bank Account",
            other: "Other",
        },
        iban: {
            label: "IBAN",
            description: "This is your IBAN account number. Only accounts in your name are allowed.",
        },
        accountOwner: {
            label: "Account Owner",
            description: "This is the owner of the bank account.",
        },
        nonSepa: {
            message: "For non-SEPA bank accounts, please contact our support team to update your bank account details.",
            contactSupport: "Contact Support",
            accountSet:
                "Your non-SEPA account has been set up. Please contact our support team to update your bank account details.",
        },
        buttons: {
            save: "Update",
        },
    },
    common: {
        buttons: {
            connectTikTok: "Connect TikTok Account",
        },
    },
    countries: {
        af: "Afghanistan",
        al: "Albania",
        dz: "Algeria",
        ad: "Andorra",
        ao: "Angola",
        ag: "Antigua and Barbuda",
        ar: "Argentina",
        am: "Armenia",
        au: "Australia",
        at: "Austria",
        az: "Azerbaijan",
        bs: "Bahamas",
        bh: "Bahrain",
        bd: "Bangladesh",
        bb: "Barbados",
        by: "Belarus",
        be: "Belgium",
        bz: "Belize",
        bj: "Benin",
        bt: "Bhutan",
        bo: "Bolivia (Plurinational State of)",
        ba: "Bosnia and Herzegovina",
        bw: "Botswana",
        br: "Brazil",
        bn: "Brunei Darussalam",
        bg: "Bulgaria",
        bf: "Burkina Faso",
        bi: "Burundi",
        cv: "Cabo Verde",
        kh: "Cambodia",
        cm: "Cameroon",
        ca: "Canada",
        cf: "Central African Republic",
        td: "Chad",
        cl: "Chile",
        cn: "China",
        co: "Colombia",
        km: "Comoros",
        cg: "Congo",
        cd: "Congo, Democratic Republic of the",
        cr: "Costa Rica",
        ci: "Côte d'Ivoire",
        hr: "Croatia",
        cu: "Cuba",
        cy: "Cyprus",
        cz: "Czechia",
        dk: "Denmark",
        dj: "Djibouti",
        dm: "Dominica",
        do: "Dominican Republic",
        ec: "Ecuador",
        eg: "Egypt",
        sv: "El Salvador",
        gq: "Equatorial Guinea",
        er: "Eritrea",
        ee: "Estonia",
        sz: "Eswatini",
        et: "Ethiopia",
        fj: "Fiji",
        fi: "Finland",
        fr: "France",
        ga: "Gabon",
        gm: "Gambia",
        ge: "Georgia",
        de: "Germany",
        gh: "Ghana",
        gr: "Greece",
        gd: "Grenada",
        gt: "Guatemala",
        gn: "Guinea",
        gw: "Guinea-Bissau",
        gy: "Guyana",
        ht: "Haiti",
        hn: "Honduras",
        hu: "Hungary",
        is: "Iceland",
        in: "India",
        id: "Indonesia",
        ir: "Iran (Islamic Republic of)",
        iq: "Iraq",
        ie: "Ireland",
        il: "Israel",
        it: "Italy",
        jm: "Jamaica",
        jp: "Japan",
        jo: "Jordan",
        kz: "Kazakhstan",
        ke: "Kenya",
        ki: "Kiribati",
        kp: "Korea (Democratic People's Republic of)",
        kr: "Korea, Republic of",
        kw: "Kuwait",
        kg: "Kyrgyzstan",
        la: "Lao People's Democratic Republic",
        lv: "Latvia",
        lb: "Lebanon",
        ls: "Lesotho",
        lr: "Liberia",
        ly: "Libya",
        li: "Liechtenstein",
        lt: "Lithuania",
        lu: "Luxembourg",
        mg: "Madagascar",
        mw: "Malawi",
        my: "Malaysia",
        mv: "Maldives",
        ml: "Mali",
        mt: "Malta",
        mh: "Marshall Islands",
        mr: "Mauritania",
        mu: "Mauritius",
        mx: "Mexico",
        fm: "Micronesia (Federated States of)",
        md: "Moldova, Republic of",
        mc: "Monaco",
        mn: "Mongolia",
        me: "Montenegro",
        ma: "Morocco",
        mz: "Mozambique",
        mm: "Myanmar",
        na: "Namibia",
        nr: "Nauru",
        np: "Nepal",
        nl: "Netherlands",
        nz: "New Zealand",
        ni: "Nicaragua",
        ne: "Niger",
        ng: "Nigeria",
        mk: "North Macedonia",
        no: "Norway",
        om: "Oman",
        pk: "Pakistan",
        pw: "Palau",
        pa: "Panama",
        pg: "Papua New Guinea",
        py: "Paraguay",
        pe: "Peru",
        ph: "Philippines",
        pl: "Poland",
        pt: "Portugal",
        qa: "Qatar",
        ro: "Romania",
        ru: "Russian Federation",
        rw: "Rwanda",
        kn: "Saint Kitts and Nevis",
        lc: "Saint Lucia",
        vc: "Saint Vincent and the Grenadines",
        ws: "Samoa",
        sm: "San Marino",
        st: "Sao Tome and Principe",
        sa: "Saudi Arabia",
        sn: "Senegal",
        rs: "Serbia",
        sc: "Seychelles",
        sl: "Sierra Leone",
        sg: "Singapore",
        sk: "Slovakia",
        si: "Slovenia",
        sb: "Solomon Islands",
        so: "Somalia",
        za: "South Africa",
        ss: "South Sudan",
        es: "Spain",
        lk: "Sri Lanka",
        sd: "Sudan",
        sr: "Suriname",
        se: "Sweden",
        ch: "Switzerland",
        sy: "Syrian Arab Republic",
        tj: "Tajikistan",
        tz: "Tanzania, United Republic of",
        th: "Thailand",
        tl: "Timor-Leste",
        tg: "Togo",
        to: "Tonga",
        tt: "Trinidad and Tobago",
        tn: "Tunisia",
        tr: "Türkiye",
        tm: "Turkmenistan",
        tv: "Tuvalu",
        ug: "Uganda",
        ua: "Ukraine",
        ae: "United Arab Emirates",
        gb: "United Kingdom of Great Britain and Northern Ireland",
        us: "United States",
        uy: "Uruguay",
        uz: "Uzbekistan",
        vu: "Vanuatu",
        ve: "Venezuela (Bolivarian Republic of)",
        vn: "Viet Nam",
        ye: "Yemen",
        zm: "Zambia",
        zw: "Zimbabwe",
    },
} as const;
